import { render, staticRenderFns } from "./FooterPlaceholderView.vue?vue&type=template&id=fdffb588&scoped=true"
import script from "./FooterPlaceholderView.vue?vue&type=script&lang=js"
export * from "./FooterPlaceholderView.vue?vue&type=script&lang=js"
import style0 from "./FooterPlaceholderView.vue?vue&type=style&index=0&id=fdffb588&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdffb588",
  null
  
)

export default component.exports